(function () {
  angular
    .module('kareo.errors.recent-http-history-service', [])
    .factory('recentHttpHistoryService', recentHttpHistoryService)
    .config(config);

  var httpHistory = [];
  var MAX_HISTORY_LENGTH = 10;
  var HTML_REGEX = /\.(html|svg)/i;

  function recentHttpHistoryService() {
    return {
      getRecentHttpHistory() {
        return httpHistory;
      }
    };
  }

  config.$inject = ['$httpProvider'];
  function config($httpProvider) {
    $httpProvider.interceptors.push(httpHistoryLogger);
  }

  function httpHistoryLogger() {
    return {
      request: requestInterceptor,
      response: responseInterceptor
    };
  }

  function requestInterceptor(requestConfig) {
    var stats;

    if (requestConfig.url.match(HTML_REGEX)) {
      return requestConfig;
    }

    stats = {
      requestTime: now(),
      responseTime: null,
      status: null,
      url: requestConfig.url
    };

    if (httpHistory.length === MAX_HISTORY_LENGTH) {
      httpHistory.shift();
    }

    httpHistory.push(stats);

    requestConfig.stats = stats;

    return requestConfig;
  }

  function now() {
    return new Date().getTime();
  }

  function responseInterceptor(response) {
    var stats = response.config.stats;
    if (stats) {
      stats.responseTime = now();
      stats.status = response.status;
    }
    return response;
  }
})();
